import React from 'react';
import Notification from '../../Shared/Notifications';

class NewForce extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            roleName: '',
            roles: {},
            showNotification: false,
            disabledButton: false,
        };
    }


    endItemCreation = () => {
        this.setState({showNotification: true, disabledButton: true});
        setTimeout(() => {
            this.setState({showNotification: false, disabledButton: false});
            this.props.closeDialog();
        }, 3000)   
    }

    renderNotification = () => {
        return(
            <Notification 
                show={this.state.showNotification}
                title={'Datos almacenados'}
                subtitle={'Sus datos fueron almacenados correctamente.'}
            />
        )
    }

    render() {
        return(
            <div className='space-y-12'>
                <div className="border-b border-gray-900/10 pb-12">
                    <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <div className="sm:col-span-4">
                            <p className="mt-1 text-sm/6 text-gray-600">
                                Esta informacion es completamente confidencial, asegurese de ingresar los datos correctamente.
                            </p>
                            <label htmlFor='roleName' className="text-base/7 font-semibold text-gray-900">
                                Codigo 
                            </label>
                            <div className="mt-2">
                                <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                        <input
                                            id="roleName"
                                            name="roleName"
                                            type="text"
                                            placeholder=""
                                            autoComplete=""
                                            className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                        />
                                </div>
                            </div>
                            <label htmlFor='roleName' className="text-base/7 font-semibold text-gray-900">
                                Nombre 
                            </label>
                            <div className="mt-2">
                                <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                        <input
                                            id="roleName"
                                            name="roleName"
                                            type="text"
                                            placeholder=""
                                            autoComplete=""
                                            className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <button 
                        disabled={this.state.disabledButton}
                        onClick={() => {this.endItemCreation()}}
                        type="button"
                        className="rounded-md bg-emerald-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-emerald-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600">
                        Finalizar creacion
                    </button>
                </div>
                {this.renderNotification()}
            </div>
        )
    }  
}

export default NewForce;